import { Button } from '../ui/button';
import { IconPlus, IconGripVertical } from '@tabler/icons-react';
import SentenceCard from './SentenceCard';

const ContentManagementSection = ({ formik, contentManagement }) => {
    const { addNewSentence } = contentManagement;

    return (
        <div className="space-y-4">
            <div className="flex items-center justify-between">
                <div>
                    <label className="text-sm font-medium text-foreground">Lesson Content</label>
                    <p className="text-xs text-muted-foreground">
                        Manage sentences and their translations for the lesson
                    </p>
                </div>
                <Button
                    type="button"
                    variant="outline"
                    size="sm"
                    onClick={() => addNewSentence()}
                >
                    <IconPlus className="h-4 w-4 mr-1" />
                    Add Sentence
                </Button>
            </div>

            <div className="space-y-4">
                {formik.values.content_ext.map((sentence, sentenceIndex) => (
                    <SentenceCard
                        key={sentenceIndex}
                        sentence={sentence}
                        sentenceIndex={sentenceIndex}
                        totalSentences={formik.values.content_ext.length}
                        contentManagement={contentManagement}
                    />
                ))}

                {formik.values.content_ext.length === 0 && (
                    <div className="text-center py-12 border-2 border-dashed border-muted-foreground/25 rounded-md">
                        <IconGripVertical className="mx-auto h-8 w-8 text-muted-foreground mb-4" />
                        <h3 className="text-sm font-semibold mb-2">No content yet</h3>
                        <p className="text-xs text-muted-foreground mb-4">
                            Start building your lesson by adding your first sentence
                        </p>
                        <Button
                            type="button"
                            variant="outline"
                            onClick={() => addNewSentence()}
                        >
                            <IconPlus className="h-4 w-4 mr-2" />
                            Add First Sentence
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ContentManagementSection; 